module.exports = __webpack_public_path__ + "static/cicada_img3-f0e10e5d6e1454a52395eb63e164b34d.png";